exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-row[data-v-7a570b35]{font-weight:600}", ""]);

// exports
